var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-suggestions-row",style:({background: _vm.colors.messageList.bg})},_vm._l((_vm.suggestions),function(suggestion,idx){return _c('button',{key:idx,staticClass:"sc-suggestions-element",style:({
      borderColor: _vm.colors.sentMessage.bg,
      color: _vm.colors.sentMessage.bg
    }),on:{"click":function($event){return _vm.$emit('sendSuggestion', suggestion)}}},[_vm._v(" "+_vm._s(suggestion)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }